// extracted by mini-css-extract-plugin
export default {"pop-up":"pop-up___cVs14"};